import { render, staticRenderFns } from "./DeliveryListActivity.vue?vue&type=template&id=e7866640&"
import script from "./DeliveryListActivity.vue?vue&type=script&lang=js&"
export * from "./DeliveryListActivity.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryListActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports